// Fichier généré par utility_scripts/gen-mapbox-token.sh à partir du secret GSM
// 'sec-<env>-<tenant>-<app>-mapbox_access_token' (modèle : mapbox-token.template.ts).
// Le fichier généré est ignoré par git : le token ne doit pas revenir dans le dépôt.
export const mapboxAccessToken = 'pk.eyJ1IjoidG9taW1pIiwiYSI6ImNtdWF4eGRsNzFianYyeHM5ZjM2MGU0bGoifQ.Q4DQhAKLi3ndjGLNaKiJjQ';
